import { css } from "styled-components";

export const pageMaxWidthCss = css`
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
`;

export const loadingStateCss = css<{ $isLoading?: boolean }>`
  ${({ $isLoading }) =>
    $isLoading
      ? css`
          * {
            color: transparent !important;
            text-shadow: 0 0 10px rgba(0, 0, 0, 0.5) !important;
          }
          a:after,
          div:after,
          svg {
            opacity: 0.2;
          }
        `
      : ""}
`;
